
module.exports = require('./lib');




//////////////////
// WEBPACK FOOTER
// ./~/socket.io-stream/index.js
// module id = 421
// module chunks = 0